<div class="div-bread">
  <lib-elux-breadcrumb [routes]="breadcrumbRoutes" />
</div>

@if (title) {
  <div class="p-5 div-title">
    <span class="subtitle-1 c-blue">
      {{ title }}
    </span>
  </div>
}
